<template>
    <div class="row no-gutters body">
        
        <div class="col-12">
            <div class="row no-gutters">
                <div class="col-lg-3 middle-background"></div>
                <div class="col-md-12 col-lg-6 middle-background main-card pb-5">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class="row no-gutters mt-5" v-if="!currentUserProfileId && currentUserProfileId === undefined">
                        <div class="col-lg-12 pb-3">
                            <div class="row no-gutters">
                                <br />
                            </div>
                            <div class="ml-3 mr-3 mt-lg-2">
                                <no-profile-id-component></no-profile-id-component>
                            </div>
                        </div>
                    </div>
                    <div class=" no-gutters mt-5 "  v-else>
                      <div class="col-12 pb-5 mb-4" v-if="pageloaderForSelectedUser">
                        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
                      </div>
                        <div class="col-lg-12" v-else> 
                            <div class="row no-gutters">
                                <br />
                            </div>
                            <div class="row no-gutters mb-3 ml-3" v-if="currentRoute == 'selectedUserPeople'" @click="moveToUserProfileScreen">                  
                              <img src="../assets/Back.svg" class="img-fluid mr-1 pointer" alt="back" />
                              <div class="d-flex flex-column">
                                <span class="ml-2 fontsize16 my-auto proximanova-bold black prof-details pointer hover">{{firstname}} {{lastname}}</span>  
                                <div v-if="selectedUserAliasName" class="proximanova ml-1 fontsize12 black">@{{selectedUserAliasName}}</div>
                              </div>                   
                            </div>
                            <nav class="nav card-header1 d-flex justify-content-between  ml-3 mr-3 mt-2" id="nav">
                                <div class="proximanova-bold blue fontsize12">
                                    <div class=" no-gutters">
                                        <ul class="nav nav-tabs ">
                                            <li class="nav-item" v-if="this.currentRoute != 'selectedUserPeople'"> 
                                                <a 
                                                 class="proximanova pointer"
                                                :class="{'proximanova-semibold blue border-tab':activeClass == 'suggested'}"
                                                @click="toggleActiveClass('suggested')"
                                                id="suggested"                                                            
                                                >Suggested</a>
                                            </li>
                                            <div class="verticaline mt-1" v-if="this.currentRoute != 'selectedUserPeople'"> | </div>
                                            <li class="nav-item" > 
                                                <a 
                                                 class="proximanova pointer"
                                                :class="{'proximanova-semibold blue border-tab':activeClass == 'followers'}"
                                                @click="toggleActiveClass('followers')"
                                                id="followers"                                                            
                                                >Followers</a>
                                            </li>
                                            <div class="verticaline mt-1"> | </div>
                                            <li class="nav-item "> 
                                                <a 
                                                 class="proximanova pointer"
                                                :class="{'proximanova-semibold blue border-tab':activeClass == 'following'}"
                                                @click="toggleActiveClass('following')"
                                                id="following"                                                            
                                                >Following</a>
                                            </li>                                            
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="d-flex mr-1" >
                                    <img src="../assets/Search_People.svg" class="img-fluid" />
                                </div> -->
                            </nav>                            
                        </div>
                    </div>
                    <div v-if="showsuggested">
                        <suggetsed-people-tab></suggetsed-people-tab>
                    </div>
                    <div v-if="showfollowers">
                      <div class="col-12 mt-3 myvideosection d-flex justify-content-lg-start justify-content-md-start justify-content-sm-start pb-2">
                        <span
                          class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 ml-3 p-1"
                          :class="{'activeVideoSub':activeFollowersClass == 'people_tab'}"
                          id="people_tab"
                          @click="changeFollowersPillBtnColour('people_tab')">People</span>
                        <span
                          class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                          :class="{'activeVideoSub':activeFollowersClass == 'company_tab'}"
                          id="company_tab"
                          @click="changeFollowersPillBtnColour('company_tab')">Company</span>
                      </div>
                      <div v-if="peopleFollowers">
                        <followers-tab :userProfileDetails="userProfileDetails"></followers-tab>
                      </div> 
                      <div v-if="companyFollowers">
                        <companyFollowersTab :userProfileDetails="userProfileDetails"></companyFollowersTab>
                      </div>                       
                    </div>
                    <div v-if="showfollowing">
                      <div class="col-12 mt-3 myvideosection d-flex justify-content-lg-start justify-content-md-start justify-content-sm-start pb-2">
                        <span
                          class="fontsize14 black80 proximanova pillbtn mr-2 ml-3 mr-lg-3 p-1"
                          :class="{'activeVideoSub':activeFollowingClass == 'people_tab'}"
                          id="people_tab"
                          @click="changeFollowingPillBtnColour('people_tab')">People</span>
                        <span
                          class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                          :class="{'activeVideoSub':activeFollowingClass == 'company_tab'}"
                          id="company_tab"
                          @click="changeFollowingPillBtnColour('company_tab')">Company</span>
                      </div>
                      <div v-if="peopleFollowing">
                        <following-tab :userProfileDetails="userProfileDetails"></following-tab>  
                      </div>     
                      <div v-if="companyFollowing">
                        <companyFollowingTab :userProfileDetails="userProfileDetails"></companyFollowingTab>
                      </div>                 
                    </div>
                </div>
                <div class="col middle-background">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class="row row no-gutters">
                        <br />
                    </div>
                    <pendingActivities />
                </div>
            </div>
        </div>
        <!-- <Footer class="footer d-block d-sm-block d-md-block d-lg-none" /> -->
    </div>   
</template>
<script>
import pendingActivities from "../components/PendingActivities.vue";
import followersTab from "@/components/SuggestivePeopleTabs/Followers.vue"
import followingTab from "@/components/SuggestivePeopleTabs/Following.vue"
import companyFollowersTab from "@/components/SuggestivePeopleTabs//CompanyFollowers.vue"
import companyFollowingTab from "@/components/SuggestivePeopleTabs//CompanyFollowing.vue"
import suggetsedPeopleTab from "../components/SuggestivePeopleTabs/SuggestedPeopleTab.vue"
import NoProfileIdComponent from '../components/NoProfileId.vue'
import sessionUtils from '@/js/session-util.js'
import httpuserprofile from "@/js/http-userprofile.js";
export default {
components: {
    pendingActivities,
    followersTab,
    followingTab,
    companyFollowersTab,
    companyFollowingTab,
    suggetsedPeopleTab,
    NoProfileIdComponent
},
data(){
    return{        
        profileId: null,
        currentUserProfileId: null,
        activeClass: 'suggested',
        showsuggested: false,
        activeFollowersClass : 'people_tab',
        showfollowers: false,
        peopleFollowers : false,
        companyFollowers : false,
        activeFollowingClass : 'people_tab',
        showfollowing: false,
        peopleFollowing : false,
        companyFollowing : false,
        //selected user info
        pageloaderForSelectedUser : false,
        currentRoute : null,
        firstname : '',
        lastname : '',
        selectedUserAliasName : null,
        selectedUserInSamePage : false,
        userProfileDetails : {},
    }
},
watch: {
  '$route.name': function () {
      this.resetData() 
    },
    '$route.params.id': function () {
      this.resetData() 
    },
    '$route.params.peopleType': function () {
      this.resetData() 
    }
  },
methods:{
  moveToUserProfileScreen() {
    this.$router.go(-1)
  },
  resetData() {
    // update tab data to default
    this.showsuggested = false;
    this.showfollowers = false;
    this.peopleFollowers = false;
    this.companyFollowers = false;
    this.showfollowing = false;
    this.peopleFollowing = false;
    this.companyFollowing = false;
    this.currentUserProfileId = sessionUtils.getUserProfileId();
    //check prev route and current route to handle data without pageloading
    if(this.currentRoute == 'selectedUserPeople' && this.$route.name == 'selectedUserPeople'){
      console.log("into")
      this.activeClass= this.$route.params.peopleType;
      console.log("into 1 : ", this.activeClass)
      this.selectedUserInSamePage = false;
      this.toggleActiveClass(this.activeClass);
    }else{
      this.currentRoute = this.$route.name;
      this.selectedUserInSamePage = false;
      //if current route is selected user
      // get aliasname and get user data and then fetch user info based on router param(follower/following)
      if(this.currentRoute == 'selectedUserPeople'){
        this.pageloaderForSelectedUser = true;
        this.selectedUserAliasName = this.$route.params.id;
        this.activeClass= this.$route.params.peopleType;
        this.getUserProfileInfoByAliasName(this.selectedUserAliasName)
      }else{
        // if fetching the data of loggedin user
        var active = sessionUtils.getPeopleActiveTab();
        console.log("watch active : ", active)
        if(!active){
          this.activeClass = "suggested"
        }else{
            this.activeClass= active;
        }
        if(this.currentUserProfileId){
        this.toggleActiveClass(this.activeClass);
        }else{
          this.showsuggested = false;
        }
      }
    }
  },
  // set active tab
    toggleActiveClass(elementId) {        
        this.noResults = false;
        this.activeClass = elementId;
        sessionUtils.setPeopleActiveTab(elementId)
        if(this.currentRoute == 'selectedUserPeople' && this.selectedUserInSamePage){
          sessionUtils.setPeopleActiveTab(elementId)
          this.$router.push({name: 'selectedUserPeople', params: { id: this.selectedUserAliasName , peopleType : elementId}});
        }else{
        if(this.currentRoute == 'selectedUserPeople'){
          this.selectedUserInSamePage = true;
        }
        if (elementId == "suggested") {
            this.suggested();
        }else if (elementId == "followers") {
            this.showfollowerlist();
        }else if (elementId == "following") {
            this.showfollowinglist();
        }
        }
    },
    suggested(){
        this.showsuggested = true;
        this.activeFollowersClass = 'people_tab';
        this.showfollowers = false;
        this.peopleFollowers = false;
        this.companyFollowers = false;
        this.activeFollowingClass = 'people_tab';
        this.showfollowing = false;
        this.peopleFollowing = false;
        this.companyFollowing = false;
    },
    showfollowerlist(){
        this.showsuggested = false;
        this.activeFollowersClass = 'people_tab';
        this.showfollowers = true;
        this.peopleFollowers = true;
        this.companyFollowers = false;
        this.activeFollowingClass = 'people_tab';
        this.showfollowing = false;
        this.peopleFollowing = false;
        this.companyFollowing = false;
    },
    showfollowinglist(){
        this.showsuggested = false;
        this.activeFollowersClass = 'people_tab';
        this.showfollowers = false;
        this.peopleFollowers = false;
        this.companyFollowers = false;
        this.activeFollowingClass = 'people_tab';
        this.showfollowing = true;
        this.peopleFollowing = true;
        this.companyFollowing = false;
    },
    changeFollowersPillBtnColour(followerclass){
      this.activeFollowersClass = followerclass;
      if(followerclass == 'people_tab'){
        this.peopleFollowers = true;
        this.companyFollowers = false;
      }else if(followerclass == 'company_tab'){
        this.peopleFollowers = false;
        this.companyFollowers = true;
      }
    },
    changeFollowingPillBtnColour(followingClass){
      this.activeFollowingClass = followingClass;
      if(followingClass == 'people_tab'){
        this.peopleFollowing = true;
        this.companyFollowing = false;
      }else if(followingClass == 'company_tab'){
        this.peopleFollowing = false;
        this.companyFollowing = true;
      }
    },
    getUserProfileInfoByAliasName(useraliasname){
      httpuserprofile
        .get("/userprofile/getUserByAliasName/" + useraliasname)
        .then(response => {
          this.pageloaderForSelectedUser = false;
          this.userProfileDetails = response.data; 
          this.firstname = response.data.firstName;
          this.lastname = response.data.lastName;
          this.toggleActiveClass(this.activeClass);
        }).catch((e) => {
          console.log(e)
          this.pageloaderForSelectedUser = false;
        })
    }
},  
created() { 
    window.scrollTo(0, 0);
    this.currentUserProfileId = sessionUtils.getUserProfileId();
    this.currentRoute = this.$route.name;
    if(this.currentRoute == 'selectedUserPeople'){
      this.pageloaderForSelectedUser = true;
      this.selectedUserAliasName = this.$route.params.id;
      this.activeClass= this.$route.params.peopleType;
      this.selectedUserInSamePage = false;
      this.getUserProfileInfoByAliasName(this.selectedUserAliasName)
    }else{
    var active = sessionUtils.getPeopleActiveTab();
    if(!active){
      this.activeClass = "suggested"
    }else{
        this.activeClass= active;
    }
      if(this.currentUserProfileId){
      this.toggleActiveClass(this.activeClass);
      }else{
        this.showsuggested = false;
      }
    }
},
}
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.loadingBgImg1{
    background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 20px 20px;
}
.list-group-item{
  padding: .25rem 0.5rem;
  border: none;
  border-radius: 5px;
}
.list-group-item:hover{
    background: rgba(31,31,31,.1);
}
.modal-footer{
  background-color: #ffffff
}
.font12-bold_filter{
  font-size: 14px;
  font-weight: bold;
  color: #1F1F1F;
}
.font12-bold{
  font-size: 14px;
  font-weight: bold;
  color: #1F1F1F;
}
.closebtnmouseover {
    padding-top: 2px;
    padding-left: 2px;
    padding-right: 2px;
    border: 1px solid white;
}
.closebtnmouseover:hover {
  /* margin-top: -4px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  padding-left: 6px;
  padding-right: 3px; */
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}

.profilestrength {
  margin-left: 0px !important;
}
.line1 {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.sign-in-button{
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  opacity: 30%;
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1
}
.sign-in-button::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
.sign-in-button:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}
.navtoPage {
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  padding-left : 5px;
  padding-top: 2px;
  cursor: pointer;  
}
.navtoPage::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius: 20px;
  background-color :  rgba(29, 27, 27, 0.1);
}
.navtoPage:hover:before {
  cursor: pointer;
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}
.text-color{
  color: #0078ff;
  font-size: 12px;
}
.button-create-font {
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: bold;
}
.input-group-append{
  margin-left: 0  !important;
}
.badge{
  transform: scale(1.6) !important;
  width: 23px;
  padding-top: 6px;
  height: 23px;
  font-size: 50%;
}
.badge-success {
  color: #fff;
  background-color:black;
}
.badge-fill {
  padding-right: .6em;
  padding-left: 0.8em;
  border-radius: 10rem;
}
#filterDropdown{
  left : 57%;
  z-index: 3;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 360%;
}
.horizonline1{
  border-bottom: 1px solid #E9EBF0;
}

#followinguser{
  transition : 0.5s all ease;
  position : relative;
  background-color: #007AFF;        
  border-radius: 4px;
  padding-bottom: 5px;    
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-left: 10px !important;
  z-index : 1;
  text-align: right;
}
#followinguser::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 50%;
  right : 50%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
#followinguser:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  padding-bottom: 5px;    
  padding-right: 10px !important;
  padding-top: 5px !important;
  border-radius:4px;
}
#followinguser a{
  margin-left:5px;
  color: #FFF !important;
  cursor: pointer;
}
.searchtext{
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
#nameBlock:hover{
  color:#007AFF !important;
}
#profilevideo{
  width: 100%;
  border-radius: 4%;
  object-fit: fill;
}
.card-padding{
  padding-right: 0px !important;
}
.vbottom{
  position: relative;
  top: 100%;
  transform: translateY(-100%); 
}
#follow a:hover{
    color: white !important;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn:hover {
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
  /* font-weight: bold; */
}
.no-record-card{
  background-color: #A1A6B3 !important;
  opacity: 6%;
  height: 15rem;
  border-radius: 10px;
}
.top-margin{
  margin-top: -300px !important;
  margin-left: auto;	
  margin-right: auto;	
  display: block;
}
.max-height{
  height: 15rem;
}
.dropdown-menu{
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.right-align{
  margin-right: 10px;;
}
.card-img-overlay {
  padding: 0 !important;
}
.black_overlay1 {
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 4px 4px 5px 4px;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 10%, #000000 100%);
  border-radius: 0 4px 5px 4px;
}
.card-img-overlay:hover #playvideobtn{
  display: block;
}
#playvideobtn {
  display: block;
  margin-left: 45%;
  margin-top: 12%;
  margin-bottom: 5%;
  cursor: pointer;
}
.card-img-overlay:hover #playvideobtn{
  display: block !important;
}
.display-button{
  display: none !important;
}
.no-image{
  margin-bottom: 5%;
}
.footer {
  position: fixed;
  bottom: 0;
}
.modal-content{
  border-radius: 10px  !important;
}
.modal-height{
  height: auto;
  margin-top: 5% !important;
  width: 100% !important;
  border-radius: 10px !important;
}
.text-design{
  background-color: #A1A6B3;
 /* opacity: 10%; */
  color: black;    
}
#bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.modal-body{
  background-color: #000000
}
.header {
  position: fixed;
  width: 100%;
  z-index: 10;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.header__content-text {
  text-align: center;
  padding: 15px 20px;
}
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
}
.footer{
  z-index: 5;
}
.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
}
.nav{ 
  background-color: #f0f2f5  !important; 
  border-radius: 8px !important;
}
.video-player{
  border-radius: 20px; 
  overflow: hidden; 
}
.welcomename {
  font-size: 14px !important;
}
.dot {
  height: 45px;
  width: 45px;
  background-color: #1F1F1F;
  border-radius: 50%;
  display: inline-block;
}
.btn-color{
  border-color: #1F1F1F;
}
.navbar {
  padding: 0px 0px 0px 0px !important;
  z-index: 100;
}
.nav{
  flex-wrap: unset !important;
}
.padding-follow{
    padding-bottom:  0.5rem;
}
.proximanova-semibold blue {
  color: #0078ff;
  font-weight: bold;
  letter-spacing: 0;
}
.imgborder1 {
  padding: 10px 15px 10px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.check-with-label:checked + .label-for-check {
  font-weight: bold;
}
.text-color1{
  color: #FFFFFF !important;
  font-size: 14px  !important;
}
.text-color2{
  color: #FFFFFF !important;
  font-size: 12px  !important;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
#profImage{
  width: 45px;
  height: 45px;
  border:1px solid #ced4da;
}
#profImage:hover{
  border: 1px solid #007AFF;
}
.hover {
  cursor: pointer;
}
.video{ 
  width: 100%;
}
#follow{
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  text-align: right;
  /* right:2%; */
  padding-left : 5px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
}
#follow::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 10%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(31,31,31,.3);
}
#follow:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  border-radius:4px;
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
#followImage1{
  width: 30px;
  height: 30px;  
}
.form-control:focus{
  outline: none !important;
  box-shadow: none !important;   
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
input:focus,
textarea:focus {
  outline: none; /** For Safari, etc **/
  border: transparent;
}
.bigger-font{
  font-weight: bold;
}
.noResult{
  zoom: 6;
  margin-left: 5px;
  margin-top: -60px;
}
.padding{
  padding: 5px !important;
}
.padding-top{
  position: absolute;
  right: 2%;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.card-img-top {
  object-fit: cover;
}
@media only screen and (max-width: 539px) {
    .pageloader {
        width: 20%;
        margin-top: 25%;
    }
    .padding-top{
        padding-top: 0.8rem;
        font-size:10px
    }
    #followinguser{
        margin-left: 0%;
    }
    #followinguser a{
        font-size: 8px;
    }
    #follow a{
        font-size: 8px;
        /* padding-bottom: 1rem !important; */
    }   
    /* .fontsize12{
        font-size: 8px !important;
    } */
    .topmenubar {
        margin-left: 1.5em;
    }
    #profImage{
        width: 24px;
        height: 24px;
    }
    .loadingBgImg{
        background-size: 20px 20px;
    }
    .loadingBgImg1{
        background-size: 15px 15px;
    }
}
@media screen and (min-width: 300px) and (max-width: 350px) {    
    #playvideobtn {
        margin-left: 40%;
        margin-top: 25%;
    }
    #filterDropdown{
        left : 47%;
    }
    #playvideobtn {
        margin-left: 40%;
    }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
#filterDropdown{
 left : 47% 
}
#playvideobtn {
  margin-left: 40%;
  margin-top: 35%;
}
nav ul li a {
    display: block;
    padding: 0.5rem 0.5rem !important;
    color: grey;
    text-decoration: none;
    display: block;
    flex: 0 1 auto;
    list-style-type: none;
    /* background: #fafafa; */
    font-size: 10px;
    max-width: 200px;
}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}

@media screen and (min-width: 300px) and (max-width: 400px) {
    nav ul li a{
        padding: 0.5rem 0.5rem;
    }
    #followImage{
        width: 15px;
        height: 15px;
        transform: scale(1.6)  !important;
        /* border: 1px solid black; */
    }
    .font16-bold{
        font-size: 8px  !important;
    }
}
@media screen and (min-width: 400px) and (max-width: 500px) {
    #filterDropdown{
        left : 47% 
    }
    #playvideobtn {
        margin-left: 40%;
        margin-top: 30%;
    }
    #followImage{
        width: 18px;
        height: 18px;
    }
}
@media only screen and (max-width: 600px) {
    .font12-60opacity{
        font-size: 10px !important;
    }
    .font14bold{
        font-size: 12px !important
    }
    
    .font16-bold{
        font-size: 12px;
    }
    .sign-in-button{
        font-size: 12px;
    }
    .pageloader {
        width: 20%;
        margin-top: 25%;
    }
    .padding-top{
        padding-top: 0.8rem;
        /* font-size:10px */
    }
    #following{
        margin-left: 0%;
    }
    #following a{
        font-size: 8px;
    }
    #follow a{
        font-size: 8px;
        /* padding-bottom: 1rem !important; */
    }
    .font12-bold{
        font-size: 10px  !important;
    }    
    /* .fontsize12{
        font-size: 8px !important;
    }    */
    .topmenubar {
        margin-left: 1.5em;
    }
}
@media screen and (min-width: 500px) and (max-width: 600px) {
    #filterDropdown{
        left : 47% 
    }
    #playvideobtn {
        margin-left: 45%;
        margin-top: 25%;
    }
}
@media screen and (max-width: 900px) and (min-width: 600px) {
    #filterDropdown{
        left : 55% 
    }
    #playvideobtn {
        margin-left: 40%;
    }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
    #filterDropdown{
        left : 55% 
    }
    #playvideobtn {
        margin-left: 45%;
        margin-top: 15%;
    }
}
@media screen and (min-width: 900px) and (max-width: 1100px) {
    #playvideobtn {
        margin-left: 35% !important;
    }
}
@media screen and (min-width: 900px) and (max-width: 1295px) {   
   #filterDropdown{
        left : 55% 
    }  
}
</style>
